import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import AppRoutes from './routes';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Loader from './components/layout/Loader';
import { useLoading } from './hooks/useLoading.jsx';

// CSS files are loaded in index.html from /public folder

function App() {
  const { isLoading } = useLoading();

  useEffect(() => {
    // Add the style to hide the reCAPTCHA badge
    const style = document.createElement('style');
    style.id = 'hide-recaptcha-style';
    style.innerHTML = `
      .grecaptcha-badge {
        visibility: hidden !important;
      }
    `;
    document.head.appendChild(style);

    // Cleanup: Remove the style when component unmounts
    return () => {
      const existingStyle = document.getElementById('hide-recaptcha-style');
      if (existingStyle) {
        existingStyle.remove();
      }
    };
  }, []);

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={import.meta.env.VITE_RECAPTCHA_SITE_KEY || ''}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: 'head',
      }}
    >
      <Router>
        <div id="wrapper">
          <Header />
          <AppRoutes />
          <Footer />
          <Loader show={isLoading} />
        </div>
      </Router>
    </GoogleReCaptchaProvider>
  );
}

export default App;
